export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";

// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";

export const headers = [
    { label: 'SELECIONAR', key: 'checkbox', isVisible: true },
    { label: 'ID', key: 'id', isVisible: true },
    { label: 'Título', key: 'titulo', isVisible: true },
    { label: 'Tipo', key: 'tipo', isVisible: true },
    { label: 'Movimentação', key: 'movimentacao', isVisible: true },
    { label: 'Origem', key: 'origem', isVisible: true },
    { label: 'Destino', key: 'destino', isVisible: true },
    { label: 'Situação', key: 'situacao', isVisible: true },
    { label: 'Data', key: 'data', isVisible: true },
    { label: 'Contratação', key: 'contratacao', isVisible: true },
    { label: 'Obs', key: 'obs', isVisible: true },
  ];


  export const mockData = [
      {
        id: 3547,
        titulo: 'DI 394172 P CIAL GRANDE MISTO AMARELO 4507502083 / 14 PALETES DE GPO',
        tipo: 'MISTO',
        movimentacao: 'Transferência',
        origem: 'Morrial Nova',
        destino: 'Campina Grande',
        situacao: 'Em Armazen',
        data: '23/03/2023',
        contratacao: '23/03/2023',
        obs: 'DI 394172 P CIAL CAMPINA GRANDE - GPO',
      },
      {
        id: 3834,
        titulo: 'VEÍCULO SEM CONV IMTRAÇÃO',
        tipo: 'FIMOS',
        movimentacao: 'Transferência',
        origem: 'Morrial Nova',
        destino: 'Aracaju',
        situacao: 'Aguardando Chegada',
        data: 'Sendo',
        contratacao: 'Não informado',
        obs: 'GPO - SECO / PAR ARBAALI FROM YEMEN ???/ ??? BURACID???',
      },
      {
        id: 7443,
        titulo: 'Exemplo Título SECO',
        tipo: 'SECO',
        movimentacao: 'Expedição',
        origem: 'Morrial Nova',
        destino: 'Dest. Exemplo',
        situacao: 'Aguardando',
        data: '25/02/2025',
        contratacao: '25/02/2025',
        obs: 'ROTA SECO',
      },
    ];

